export const queryGetAllShortcuts = `query GetTermsAndConditions($id: String!) {
  termsAndConditionsProd(id: $id) {
    name
    value {
      json
      links {
        assets {
          block {
            sys {
              id
            }
            url
          }
        }
      }
    }
  }
}`
